import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gb0001',
    ecrans: ['00-2']
});

